// router.js

import { createRouter, createWebHistory } from 'vue-router'
import UserLogin from './components/UserLogin.vue'
import UserRegister from './components/UserRegister.vue'
import HomePage from './components/HomePage.vue'
import NotFound from './components/NotFound.vue'
import UserDetails from './components/UserDetails.vue'
import ResetPassword from './components/ResetPassword.vue'
import PasswordResetComponent from './components/PasswordResetComponent.vue'
import UserActivitats from './components/UserActivitats.vue'
import CalendariReserva from './components/CalendariReserva.vue'
import TermsPrivacy from './components/TermsPrivacy.vue'
import InfoContact from './components/InfoContact.vue'
import ConfirmarEmail from './components/ConfirmarEmail.vue'
import ContenidoCurso from './components/ContenidoCurso.vue'
import ContenidoDocente from './components/ContenidoDocente.vue'
import UserInspira from './components/UserInspira.vue'
import UtilsPlantilles from './components/UtilsPlantilles.vue'
import AdminComponent from './components/AdminComponent.vue'
import ItinerarioFormativo from './components/ItinerarioFormativo.vue'
import UserVerifyResend from './components/UserVerifyResend.vue'


const routes = [
  {
    path: '/',
    component: HomePage,
    name: 'Home',
    props: true, // This allows you to pass props to the component through route parameters
    meta: { requiresAuth: false }
  },
  {
    path: '/quiz/join/:session_code',
    name: 'JoinQuiz',
    component: () => import('./components/QuizzJoin.vue')
  },
  {
    path: '/quiz/participant/:session_code/:participant_id',
    name: 'QuizzParticipant',
    meta: { requiresAuth: false },
    component: () => import('./components/QuizzParticipant.vue')
  },
  {
    path: '/quiz/teacher/:session_code',
    name: 'QuizzTeacher',
    meta: { requiresAuth: true },
    component: () => import('./components/QuizzTeacher.vue')
  },
  { path: '/inspira', component: UserInspira, meta: { requiresAuth: true } },
  { path: '/plantilles', component: UtilsPlantilles, meta: { requiresAuth: false } },
  { path: '/login', component: UserLogin, meta: { requiresGuest: true } },
  { path: '/register', component: UserRegister, meta: { requiresGuest: true } },
  { path: '/actividades', component: UserActivitats, meta: { requiresAuth: true } },
  { path: '/itinerario', component: ItinerarioFormativo, meta: { requiresAuth: true } },
  { path: '/curso/:uid', component: ContenidoCurso, meta: { requiresAuth: true } },
  { path: '/curso_inspira/:uid', component: ContenidoDocente, meta: { requiresAuth: true } },
  { path: '/perfil', component: UserDetails, meta: { requiresAuth: true } },
  { path: '/reservas', component: CalendariReserva, meta: { requiresAuth: true } },
  { path: '/condiciones-y-privacidad', component: TermsPrivacy },
  { path: '/contacto', component: InfoContact },
  { path: '/administrador', component: AdminComponent, meta: { requiresAuth: true } },
  { path: '/passreset', name: 'PasswordReset', component: PasswordResetComponent },
  { path: '/verifyresend', name: 'VerifyResend', component: UserVerifyResend },
  { path: '/reset/:uid/:token', name: 'ResetPassword', component: ResetPassword },
  { path: '/confirm-email/:key', name: 'ConfirmarEmail', component: ConfirmarEmail, props: true },
  { path: '/:catchAll(.*)', component: NotFound }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('authToken');
  // Si la ruta es sólo para invitados y ya está logueado → Home
  if (to.matched.some(record => record.meta.requiresGuest) && isAuthenticated) {
    return next({ name: 'Home' });
  }
  // Si requiere auth y no está logueado → Login
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    return next({ path: '/login' });
  }
  next();
});


export default router
